var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTimezone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_timezone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9977",
    "data-name": "Path 9977",
    d: "M94.723,89.1a5.033,5.033,0,1,0,5.033,5.033A5.038,5.038,0,0,0,94.723,89.1Zm0,8.828a3.795,3.795,0,1,1,3.795-3.795A3.8,3.8,0,0,1,94.723,97.928Z",
    transform: "translate(-80.447 -79.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9978",
    "data-name": "Path 9978",
    d: "M10,0A10,10,0,0,0,1.253,14.841a.652.652,0,0,0,.064.114A10.007,10.007,0,0,0,10,20a.67.67,0,1,0,0-1.34c-.853,0-1.733-.854-2.416-2.342a10.739,10.739,0,0,1-.42-1.074h.623a.67.67,0,1,0,0-1.34H6.8A17.742,17.742,0,0,1,6.4,10.67H9.092a.67.67,0,1,0,0-1.34H6.4A17.717,17.717,0,0,1,6.8,6.1h6.4a16.431,16.431,0,0,1,.278,1.644.67.67,0,1,0,1.331-.158c-.061-.516-.141-1.012-.237-1.487h3.154A8.608,8.608,0,0,1,18.66,10,.67.67,0,1,0,20,10,10.011,10.011,0,0,0,10,0ZM7.08,1.848a8.417,8.417,0,0,0-.715,1.276,12.237,12.237,0,0,0-.6,1.633H3.115A8.7,8.7,0,0,1,7.081,1.849ZM6.365,16.876a8.468,8.468,0,0,0,.715,1.276,8.7,8.7,0,0,1-3.966-2.908H5.76a12.366,12.366,0,0,0,.6,1.632ZM5.429,13.9H2.274a8.6,8.6,0,0,1-.905-3.233H5.062A19.37,19.37,0,0,0,5.428,13.9ZM5.063,9.33H1.369a8.592,8.592,0,0,1,.9-3.233H5.429A19.37,19.37,0,0,0,5.063,9.33ZM7.168,4.757C7.88,2.625,8.975,1.34,10,1.34c1.087,0,2.145,1.352,2.83,3.416Zm7.074,0A10.215,10.215,0,0,0,12.92,1.849a8.7,8.7,0,0,1,3.966,2.908H14.243Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9979",
    "data-name": "Path 9979",
    d: "M119.514,109.591a.671.671,0,0,0-.671.671v1.984l-1.18,1.272a.671.671,0,1,0,.983.912l1.36-1.466a.667.667,0,0,0,.178-.456v-2.247a.671.671,0,0,0-.671-.671Z",
    transform: "translate(-105.371 -98.292)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimezone);
export default __webpack_public_path__ + "static/media/ic_timezone.94674789c2516e622258d910d6d3ebf0.svg";
export { ForwardRef as ReactComponent };